/* eslint-disable default-param-last */
import { cirbState, institutionDetailsState, cirbAddtionalDetailsState } from 'models/cirb';
import { CIRB_ACTIONS } from 'actions/cirb';
import { capProcessingQueue } from '../../models/cirb';
import { CIRB_QUEUED_ACTIONS } from '../../actions/cirb/QueuedProcessAction';

export const CirbAdditoinDetailsReducer = (state = cirbAddtionalDetailsState, action) => {
  switch (action.type) {
    case CIRB_ACTIONS.SET_MISSING_PREFERENCES:
      return {
        ...state,
        missingPreference: action.payload
      };
    case CIRB_ACTIONS.SET_SITE_PREFERENCES:
      return {
        ...state,
        sitePreferences: action.payload
      };
    case CIRB_ACTIONS.SET_SITE_EVENTS:
      return {
        ...state,
        siteEvents: action.payload
      };
    case CIRB_ACTIONS.SET_SITE_APPROVALS:
      return {
        ...state,
        siteApprovals: action.payload
      };
    case CIRB_ACTIONS.SET_DUPLICATE_EVENTS:
      return {
        ...state,
        duplicateEvents: action.payload
      };
    case CIRB_ACTIONS.SET_EVENTS_HISTORY:
      return {
        ...state,
        eventsHistory: action.payload
      };
    case CIRB_ACTIONS.SET_SIGNATORY_CONTACTS:
      return {
        ...state,
        signatoryContacts: action.payload
      };
    case CIRB_ACTIONS.CLEAR_PROTOCOL_ADDITIONAL_DETAILS:
      return {
        ...state,
        siteEvents: [],
        missingPreference: [],
        duplicateEvents: [],
        eventsHistory: [],
        syncVersion: null
      };
    case CIRB_ACTIONS.CLEAR_SITE_ADDITIONAL_DETAILS:
      return {
        ...state,
        sitePreferences: [],
        signatoryContacts: [],
        siteApprovals: [],
        duplicateEvents: []
      };
    case CIRB_ACTIONS.IS_LOADING_ADDITIONAL_DETAIL:
      return {
        ...state,
        isLoadingAdditionalDetails: action.isLoadingAdditionalDetails
      };
    default:
      return state;
  }
};

export const CirbReducer = (state = cirbState, action) => {
  switch (action.type) {
    case CIRB_ACTIONS.SET_SELECTED_CIRB:
      return {
        ...state,
        selectedCirb: action.payload.data,
        selectedIndex: action.payload.index
      };
    case CIRB_ACTIONS.PROTOCOL:
      return {
        ...state,
        protocol: action.payload
      };
    case CIRB_ACTIONS.RESET:
      return {
        ...state,
        selectedCirb: action.payload.data
      };
    case CIRB_ACTIONS.GET_PROTOCOL_APPROVAL:
      return {
        ...state,
        protocolApprovalDetails: action.payload
      };
    case CIRB_ACTIONS.CLEAR_PROTOCOL_APPROVAL:
      return {
        ...state,
        protocolApprovalDetails: {}
      };
    case CIRB_ACTIONS.GET_PROTOCOL_VERSIONS:
      return {
        ...state,
        protocolVersions: action.payload.data
      };
    case CIRB_ACTIONS.SET_SITE_EVENTS:
      return {
        ...state,
        signatoryContacts: action.payload
      };
    default:
      return state;
  }
};

export const institutionDetailsReducer = (state = institutionDetailsState, action) => {
  switch (action.type) {
    case CIRB_ACTIONS.GET_SITE_DETAILS:
      return {
        ...state,
        siteDetails: action.payload
      };
    case CIRB_ACTIONS.GET_SITE_DETAILS_FAILURE:
      return {
        ...state,
        overRideCtepId: action.payload
      };
    case CIRB_ACTIONS.CLEAR_SITE_DETAILS:
      return {
        ...state,
        siteDetails: {}
      };
    default:
      return state;
  }
};

export const CirbProcessingQueueReducer = (state = capProcessingQueue, action) => {
  if (action.type === CIRB_QUEUED_ACTIONS.CURRENT_QUEUED_ITEMS) {
    return {
      ...state,
      queuedList: action.payload,
      isCheckForQueuedItems: action.payload.length > 0
    };
  }
  return state;
};

export const getCurrentQueuedItemsSelector = (state) => state.cirbProcessingQueue.queuedList;
export const getIsCheckForQueuedItemsSelector = (state) => state.cirbProcessingQueue.isCheckForQueuedItems;
